module.exports = __webpack_public_path__ + "img/banner-one-main-pic.c639592e.png";